import { render, staticRenderFns } from "./politics_table.vue?vue&type=template&id=0379524a&scoped=true&"
import script from "./politics_table.vue?vue&type=script&lang=js&"
export * from "./politics_table.vue?vue&type=script&lang=js&"
import style0 from "./politics_table.vue?vue&type=style&index=0&id=0379524a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379524a",
  null
  
)

export default component.exports